import { StyledTooltip } from "./SystemPatientResults";
import { SystemPatientResults } from "./SystemPatientResults";

export default SystemPatientResults
export { StyledTooltip }